import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';

// Previous / Next stepper for pages within the same Menu Group + Sub-section.
export function ProjectStepper({ prev, next, testId }) {
  if (!prev && !next) return null;

  return (
    <nav aria-label="Project pages" className="my-8" data-testid={testId}>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
        {prev ? (
          <Link
            to={`/page/${prev.slug}`}
            rel="prev"
            aria-label={`Previous page: ${prev.title}`}
            className="group flex-1 flex items-center gap-3 border border-border rounded-lg bg-card px-4 py-3 transition-colors hover:border-primary hover:bg-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            data-testid="stepper-prev"
          >
            <ArrowLeft aria-hidden="true" className="h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-primary" />
            <span className="min-w-0">
              <span className="block text-xs uppercase tracking-wide text-muted-foreground">Previous</span>
              <span className="block font-medium truncate transition-colors group-hover:text-primary">{prev.title}</span>
            </span>
          </Link>
        ) : (
          <span className="hidden flex-1 sm:block" aria-hidden="true" />
        )}

        {next ? (
          <Link
            to={`/page/${next.slug}`}
            rel="next"
            aria-label={`Next page: ${next.title}`}
            className="group flex-1 flex items-center justify-end gap-3 border border-border rounded-lg bg-card px-4 py-3 text-right transition-colors hover:border-primary hover:bg-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            data-testid="stepper-next"
          >
            <span className="min-w-0">
              <span className="block text-xs uppercase tracking-wide text-muted-foreground">Next</span>
              <span className="block font-medium truncate transition-colors group-hover:text-primary">{next.title}</span>
            </span>
            <ArrowRight aria-hidden="true" className="h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-primary" />
          </Link>
        ) : (
          <span className="hidden flex-1 sm:block" aria-hidden="true" />
        )}
      </div>
    </nav>
  );
}
